<p-dialog
        [(visible)]="this.visible"
        [modal]="true"
        [header]="'Create New Country'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '500px' }"
        (onHide)="this.close()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-globe"></p-inputicon>
                <input
                        pInputText
                        id="country-name"
                        [(ngModel)]="this.country.name"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Country Name"
                />
            </p-iconfield>
            <label for="country-name">Country Name <span class="text-red-500">*</span></label>
        </p-ifta-label>
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-shopping-cart"></p-inputicon>
                <input
                        pInputText
                        id="dep-market-name"
                        [(ngModel)]="this.country.depMarketName"
                        autocomplete="off"
                        class="w-full"
                        placeholder="e.g. MOC Germany"
                />
            </p-iconfield>
            <label for="dep-market-name">DEP Market Name</label>
        </p-ifta-label>
        <p-ifta-label>
            <p-multi-select
                    id="country-languages"
                    [(ngModel)]="selectedLanguages"
                    [options]="availableLanguages"
                    [filter]="true"
                    optionLabel="name"
                    placeholder="Select Languages"
                    [maxSelectedLabels]="4"
                    class="w-full"
                    appendTo="body"
            ></p-multi-select>
            <label for="country-languages">Languages</label>
        </p-ifta-label>
        <p class="text-gray-400 text-xs">With <span class="text-red-500">*</span> marked fields are
            mandatory.</p>
    </div>
    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="this.close()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Save"
                icon="pi pi-check"
                (click)="saveCountry()"
                [disabled]="this.saveDisabled"
                [loading]="this.loading"
        ></p-button>
    </div>
</p-dialog>
